export * from "@trpc/react-query/shared";

export const ENDPOINTS = [
  "loggedInViewerRouter",
  "admin",
  "apiKeys",
  "apps",
  "auth",
  "availability",
  "appBasecamp3",
  "bookings",
  "calendars",
  "calVideo",
  "credentials",
  "deploymentSetup",
  "eventTypes",
  "eventTypesHeavy",
  "features",
  "feedback",
  "holidays",
  "featureOptIn",
  "i18n",
  "me",
  "ooo",
  "payments",
  "public",
  "timezones",
  "slots",
  "travelSchedules",
  "brands",
  "schedulingRules",
  "users",
  "viewer",
  "webhook",
  "googleWorkspace",
  "oAuth",
  "delegationCredential",
  "credits",
  "filterSegments",
  "phoneNumber",
] as const;
